// extracted by mini-css-extract-plugin
export default {"fs":"_2349ab4b08 ab1d0ebc1d"};